var _rect, _rect2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeyday(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 165,
    height: 76,
    viewBox: "0 0 165 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.259888,
    width: 164.2,
    height: 76,
    rx: 12,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 20.2599,
    y: 20,
    width: 124.2,
    height: 36,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1900_18261",
    transform: "scale(0.00724638 0.025)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1900_18261",
    width: 138,
    height: 40,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIoAAAAoCAMAAAAWjZKzAAAACXBIWXMAAAsSAAALEgHS3X78AAAAPFBMVEVHcExluq9luq9luq9luq9luq9luq9luq9luq9luq9luq9luq9luq9luq9luq9luq9luq9luq9luq9luq9wnmtlAAAAE3RSTlMAYCDgEPCgwECA0DCwUJBwsqyItqVOtgAAAwFJREFUWMPtWNmCnSAMBdkXvW39/3+tEJYErM440/bl5mEUhJNDEpLcYexviNsPsZ/dtbhDOJ3jaW7551Rs2mXonHmE9KbypvKm8qbyQSrLKw9VzHlwM4c4tFamCRPSm/MZiw9U1qiOkdBHzkxLN57+aqwvphl+R0VuexOxHok405KDAVR6UW1dQFSCafs3lnUteRAGa+zLDZXgdywbYyI9X31tHh9m0nidbwCrQtMGdOWHHtTFQslbIg1Jqp3KC6wgerkqVtL7JAkgqGnaNCvUCKir7f4HsZXvrlfJQrH/AuzWiuPhhLxYw9l1Ux1AZpvtSnPrTKMCm1rA6eqXKypw5BJ+S9G6YY9azE8BQakbQDbhHiG0rKpUeI0v1izPb6h4cicDACzYvBobxZJzpqEoUVAAVD2FqNoPeTWPX1AJQ0RrmNY96qqbh0CEg1rARtfNVcCs3qO4542KMkQKUt5gXBMDLg5dQcWmccjAiRY+o6siK5XKlZHscHGZ3ZmxXPnsGuIKxhFj3iz2Wwdg086gmy7HHlKxVTMvLxPGgvxmz6i0gMsm3uVTKs299TlhhDsqYDDHcODdUjkrahylquRmiS9nzrGwcxsyc76SpttNwc4aZRdUOMlEWLI5Qmzf1UBa47gf/GaQDu6mJHVOZRnuotQLvpU/u5s1BVlwNkAUI1oGAUfOcFUODcqVB5NY8ymTqVL96G62tVjCV09ypJDYr90Gh/xC+eWaCmjwwNp6miVI1gXlMY+saOl6hRLEcbthRkfzD7VOpZoIs5mCr2k8RHxlEpCOYq6nGaBXZhr+4mNdnPTDVfZyKu3Y+FNpnwCIrqH3uW6dZCQwUbKptJ9w8VsHwFw43TN2hHe97SpIQ0nKyY5/9vfOUUuckVqjKSyjusSQLO7/kxBcKpHRhamnF3RbXhhfx0aLASTXqbtO5yC61rGIPpPe7zyXscV9KFPj/3mx32OUyc0PRJ8E6VOjfO1EQzL4n27WJ3H/f9z8HXE/Vtiv/MD/ulG+w81qjvvffpR53JPl1C4AAAAASUVORK5CYII="
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeyday);
export default __webpack_public_path__ + "static/media/heyday.8c302cf2fa39a0d32bbf29560c03a0a2.svg";
export { ForwardRef as ReactComponent };